import React, { useState } from "react";
import { Eye, EyeSlash } from "@phosphor-icons/react";

// Password field with a show/hide eye toggle. Drop-in replacement for a
// bare <input type="password">. Forwards value/onChange and any extra
// props; keeps the same className so it matches the surrounding form.
export default function PasswordInput({
  value,
  onChange,
  className = "",
  testId = "password-input",
  toggleTestId,
  ...rest
}) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        type={visible ? "text" : "password"}
        value={value}
        onChange={onChange}
        data-testid={testId}
        className={`${className} pr-12`}
        {...rest}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        data-testid={toggleTestId || `${testId}-toggle`}
        aria-label={visible ? "Hide password" : "Show password"}
        title={visible ? "Hide password" : "Show password"}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-muted_ink hover:text-forest p-1 transition-colors"
        tabIndex={-1}
      >
        {visible ? <EyeSlash size={18} weight="bold" /> : <Eye size={18} weight="bold" />}
      </button>
    </div>
  );
}
